export const ADDRESSES = "ADDRESSES";
export const ADDRESS_BUSY = "ADDRESS_BUSY";
export const ADDRESS_COUNT = "ADDRESS_COUNT";
